<template>
    <div>
        <div class="mt-4 valign-middle-children bank-reconciliation-filter">
            <div class="alert alert-danger formAlert" v-if="error">
                {{ error }}
            </div>

            <el-select
                v-model="doctype"
                :placeholder="$t.__('bankreconciliation.Filter.document_type')"
            >
                <el-option
                    v-for="doctype in doctypes"
                    :key="doctype.value"
                    :label="doctype.label"
                    :value="doctype.value"
                >
                </el-option>
            </el-select>

            <div class="form-input">
                <el-input
                    v-model="thirdname"
                    :disabled="doctype == ''"
                    :placeholder="thirdType"
                    @change="searchDocs"
                    clearable
                />
            </div>

            <el-date-picker
                :disabled="doctype == ''"
                :clearable="false"
                v-model="docDates"
                type="daterange"
                :format="datePickerFormat"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :range-separator="$t.__('bankreconciliation.Filter.to')"
                :start-placeholder="$t.__('common.labels.start_date')"
                :end-placeholder="$t.__('common.labels.end_date')"
            >
            </el-date-picker>

            <input-number
                :disabled="doctype == ''"
                :placeholder="$t.__('common.labels.amount')"
                :empty-at-start="true"
                v-model="amount"
                :min="0"
                :precision="numberFormat.precision"
                :separator-decimal="numberFormat.decimal"
                :separator-thousand="numberFormat.thousand"
            />

            <div class="form-input">
                <el-input
                    v-model="docident"
                    :disabled="doctype == ''"
                    clearable
                    @change="searchDocs"
                    :placeholder="$t.__('bankreconciliation.Filter.document_number')"
                />
            </div>

            <CompassButton
                :label="$t.__('common.actions.search')"
                type="primary"
                :disabled="doctype == ''"
                @click="searchDocs"
            />
        </div>

        <el-checkbox class="mt-2" v-model="reconciled">
            {{ $l10n.__('Documents rapprochés') }}
        </el-checkbox>

        <paginator
            v-if="sharedState.docs.length > 0"
            class="flex-right"
            :pagination="sharedState.pagination"
            @pagination:update="goToPage"
        />
    </div>
</template>

<script>
import datePickerShortCut from '../../mixins/datePickerOptionsRB.js';
import Store from './../../store/reconciliation.js';
import Paginator from '../utilities/Paginator.vue';
import InputNumber from 'vcomponents/utilities/InputNumber.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('corp');

export default {
    mixins: [datePickerShortCut],
    props: {
        transactionDate: {
            type: Date,
            required: true,
        },
    },
    data() {
        return {
            sharedState: Store.state,
            error: false,

            doctypes: [
                {
                    value: 'invoice',
                    label: this.$l10n.__('Facture client'),
                },
                {
                    value: 'creditnote',
                    label: this.$l10n.__('Avoir client'),
                },
                {
                    value: 'purInvoice',
                    label: this.$l10n.__('Facture fournisseur'),
                },
                {
                    value: 'purCreditNote',
                    label: this.$l10n.__('Avoir fournisseur'),
                },
            ],

            numberFormat: {
                precision: parseInt(App.numformat.precision),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },

            doctype: '',
            thirdname: '',
            docDates: this.generateDefaultRange(this.transactionDate),
            amount: 0,
            docident: '',
            reconciled: false,
        };
    },
    computed: {
        thirdType: function () {
            const doctypeForClient = ['creditNote', 'invoice'];
            const doctypeForSupplier = ['purInvoice', 'purCreditNote'];
            if (doctypeForClient.indexOf(this.doctype) !== -1) {
                return this.$l10n.__('Clients');
            } else if (doctypeForSupplier.indexOf(this.doctype) !== -1) {
                return this.$l10n.__('Fournisseurs');
            } else {
                return this.$l10n.__('Clients / Fournisseurs');
            }
        },

        ...mapGetters(['datePickerFormat']),
    },
    methods: {
        // Form submit
        searchDocs: function () {
            Store.docsLoading();
            this.error = false;

            const options = {
                reconciliation_doctype: this.doctype,
                reconciliation_startDate: this.docDates[0],
                reconciliation_endDate: this.docDates[1],
                reconciliation_amount: this.amount,
                reconciliation_ident: this.docident,
                reconciliation_third: this.thirdname,
                reconciliation_pagination: this.sharedState.pagination,
                reconciliation_transactionId: this.sharedState.transactionId,
                reconciliation_reconciled: this.reconciled,
            };

            $.post(
                './?_f=bankreconciliation_reconciliation&action=getDocs',
                options,
                (data) => {
                    if (data.form.status == 'failed') {
                        if (data.form.msg != '') {
                            this.error = data.form.msg;
                        }
                        Store.docsLoaded();
                        return;
                    }

                    let docs = data.data.map((doc) => {
                        return {
                            link: doc.formatted_ident.match(/href="(.*)"/)[1],
                            step: doc.step,
                            docid: doc.id,
                            ident: doc.ident,
                            thirdname: doc.thirdname,
                            dueAmount: doc.dueAmount,
                            totalAmount: doc.totalAmount,
                            formattedTotalAmount: doc.formatted_totalAmount,
                            hasDeadlines: doc.hasDeadlines == 'Y',
                            displayedDate: doc.displayedDate,
                            displayedStep: doc.formatted_step,
                        };
                    });

                    Store.setDocs(docs);
                    Store.setDoctype(this.doctype);
                    Store.setPagination(data.meta.pagination);
                    Store.docsLoaded();
                },
                'json',
            );
        },

        // Helper
        generateDefaultRange: function (date) {
            let start = moment(date).subtract(354, 'days');
            let end = moment(date).add(10, 'days');
            return [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
        },

        // Event
        goToPage(page) {
            let pagination = this.sharedState.pagination;
            pagination.current_page = page;
            Store.setPagination(pagination);

            this.searchDocs();
        },
    },
    components: {
        'input-number': InputNumber,
        Paginator,
    },
};
</script>

<style scoped lang="scss">
.bank-reconciliation-filter {
    // Reset CSS to element.io
    .el-input__prefix,
    .el-input__suffix {
        top: -5px;
    }
    .el-date-editor .el-input__inner,
    .el-date-editor.el-input__inner {
        width: 350px;
        padding: 0 30px;
    }
}
</style>
